"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _device = require("@/api/iot/device");
var _batteryWare = require("@/api/iot/batteryWare");
var _default = {
  props: ['editItem', 'roleList'],
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      btnLoading: false,
      form: {
        id: '',
        merchant_id: '',
        device_id: '',
        warehouse_no: '',
        status: '',
        is_battery: '',
        battery_no: '',
        battery_voltage: '',
        battery_electric: ''
      },
      rules: {
        username: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'change'
        }],
        role_id: [{
          required: true,
          message: '请选择终端状态',
          trigger: 'change'
        }]
      },
      merchantList: [],
      deviceList: []
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '换电柜电池仓';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            for (var key in _this.form) {
              _this.form[key] = _this.editItem[key];
            }
          }
        });
      } else {
        this.reset();
      }
    },
    'form.merchant_id': function formMerchant_id(val) {
      this.getdeviceList();
    }
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getdeviceList();
  },
  methods: {
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    // 获取商户设备列表
    getdeviceList: function getdeviceList(query) {
      var _this2 = this;
      this.loading = true;
      (0, _device.cabinetGetList)({
        terminal_no: query,
        merchant_id: this.form.merchant_id
      }).then(function (res) {
        console.log(res);
        _this2.deviceList = res || [];
        _this2.loading = false;
      });
    },
    submit: function submit() {
      var _this3 = this;
      this.$refs['form'].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(valid) {
          var res;
          return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 9;
                    break;
                  }
                  _this3.btnLoading = true;
                  _context2.next = 4;
                  return (0, _batteryWare.batteryWareSave)(_this3.form).catch(function () {});
                case 4:
                  res = _context2.sent;
                  _this3.btnLoading = false;
                  if (res) {
                    _this3.dialogVisible = false;
                    _this3.$emit('getList');
                  }
                  _context2.next = 11;
                  break;
                case 9:
                  _this3.$message({
                    message: '请检查表单错误',
                    type: 'error'
                  });
                  return _context2.abrupt("return", false);
                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};
exports.default = _default;